import type { TMessages } from '@/types/TMessages'

export const messages = {
  communicationMethod: {
    whatsapp: 'Сообщение в\n WhatsApp',
    phone: 'Звонок на\n телефон',
  },
  communicationMethodData: {
    whatsapp: 'Сообщение в WhatsApp',
    phone: 'Звонок на телефон',
  },
  preferedMethod: 'Выберите предпочтительный способ связи',
  select: 'Выбрать',
} satisfies TMessages
